import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import ProductCard from "@/components/ProductCard";
import { useCart } from "@/context/CartContext";

const COLLECTIONS = ["All", "Best Sellers", "Signature Collection", "Sweet & Warm", "Fresh & Clean", "Fruity & Tropical", "Seasonal Collection", "Limited Edition"];

const Shop = () => {
  const { products } = useCart();
  const [params] = useSearchParams();
  const initial = params.get("collection");
  const [active, setActive] = useState(COLLECTIONS.includes(initial) ? initial : "All");

  const filtered = useMemo(
    () => (active === "All" ? products : products.filter((p) => p.collections.includes(active))),
    [products, active]
  );

  return (
    <div data-testid="shop-page" className="bg-ivory">
      <section className="border-b border-line py-16 md:py-24 text-center">
        <Reveal>
          <p className="eyebrow">Shop Soy Wax Candles</p>
          <h1 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight">The Collection</h1>
          <p className="mx-auto mt-6 max-w-lg text-sm md:text-base text-stone2 leading-relaxed">
            Hand-poured soy wax candles, made in small batches in Manayunk. Find the scent your home has been waiting for.
          </p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20 py-12 md:py-16">
        <div data-testid="collection-filters" className="flex flex-wrap gap-2 border-b border-line pb-8">
          {COLLECTIONS.map((c) => (
            <button key={c} data-testid={`filter-${c.toLowerCase().replace(/[\s&]+/g, "-")}`} onClick={() => setActive(c)}
              className={`px-5 py-2.5 text-[10px] font-medium uppercase tracking-[0.22em] border transition-all duration-300 ${active === c ? "border-ink bg-ink text-ivory" : "border-line bg-white text-stone2 hover:border-ink hover:text-ink"}`}>
              {c}
            </button>
          ))}
        </div>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-stone2" data-testid="shop-result-count">{filtered.length} Candles</p>
        <div className="mt-8 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3 pb-16">
          {filtered.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
        </div>
      </section>
    </div>
  );
};

export default Shop;
